module.exports = __webpack_public_path__ + "img/bg_home.5c344952.jpg";